// extracted by mini-css-extract-plugin
export default {"noselect":"Question_noselect__JRNM4"};